import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DatatableComponent, NgxDatatableModule } from '@swimlane/ngx-datatable';

import { BillingAutoPayDetailFeatureModule } from '@amfam/billing/auto-pay/detail/feature';
import { BillingAutoPayFeatureModule } from '@amfam/billing/auto-pay/feature';
import { BillingPaymentMethodDataAccessModule } from '@amfam/billing/payment-method/data-access';
import { BillingPaymentMethodFeatureModule } from '@amfam/billing/payment-method/feature';
import { BillingPaymentaccountFeatureModule } from '@amfam/billing/paymentaccount/feature';
import { BillingSchedulepaymentFeatureModule } from '@amfam/billing/schedulepayment/feature';
import { BillingSharedUiModule } from '@amfam/billing/shared/ui';
import { PolicyPipesModule } from '@amfam/policy/pipes';
import { SharedAnalyticsModule } from '@amfam/shared/analytics';
import { DsRouterLinkModule } from '@amfam/shared/ui/ds-router-link';
import { PipesModule } from '@amfam/shared/ui/pipes';
import { BrandDirectivesModule } from '@amfam/shared/utility/brand';
import { ImpersonationModule } from '@amfam/shared/utility/impersonation';
import { SharedServicesModule } from '@amfam/shared/utility/shared-services';
import { UiKitModule } from '@amfam/ui-kit';

import { BillAccountDetailCardComponent } from './components/bill-account-detail-card/bill-account-detail-card.component';
import { BillAccountStopManagingComponent } from './components/bill-account-stop-managing/bill-account-stop-managing.component';
import { BillingOnlinePreferenceComponent } from './components/billing-online-preference/billing-online-preference.component';
import { BillingPreferencesComponent } from './components/billing-preferences/billing-preferences.component';
import { FuturePaymentsComponent } from './components/future-payments/future-payments.component';
import { NewBillAccountDetailCardComponent } from './components/new-bill-account-detail-card/new-bill-account-detail-card.component';
import { NewBillAccountStopManagingComponent } from './components/new-bill-account-stop-managing/new-bill-account-stop-managing.component';

@NgModule({
  imports: [
    SharedAnalyticsModule,
    CommonModule,
    UiKitModule,
    PipesModule,
    FormsModule,
    ReactiveFormsModule,
    PolicyPipesModule,
    SharedServicesModule,
    DsRouterLinkModule,
    ImpersonationModule,
    BrandDirectivesModule,
    NgxDatatableModule,
    BillingSchedulepaymentFeatureModule,
    BillingPaymentaccountFeatureModule,
    BillingAutoPayDetailFeatureModule,
    BillingPaymentMethodDataAccessModule,
    BillingPaymentMethodFeatureModule,
    BillingAutoPayFeatureModule,
    BillingSharedUiModule
  ],
  declarations: [
    BillAccountDetailCardComponent,
    NewBillAccountDetailCardComponent,
    NewBillAccountStopManagingComponent,
    BillAccountStopManagingComponent,
    BillingPreferencesComponent,
    FuturePaymentsComponent,
    BillingOnlinePreferenceComponent
  ],
  exports: [
    BillAccountDetailCardComponent,
    NewBillAccountDetailCardComponent,
    NewBillAccountStopManagingComponent,
    BillAccountStopManagingComponent,
    BillingPreferencesComponent,
    FuturePaymentsComponent
  ],
  providers: [DatatableComponent]
})
export class BillingDetailFeatureModule {}
